export const HamburgerConfig = {
  width: 20,
  height: 20,
  brickHeight: 2,
  brickDiagonal: 30,
};
